module.exports = __webpack_public_path__ + "static/media/mealhada-pampilhosa-3.101b9323.jpg";